function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ta3k6d-euiHeaderLinks__list",
  styles: "white-space:nowrap;display:flex;align-items:center;label:euiHeaderLinks__list;"
} : {
  name: "1ta3k6d-euiHeaderLinks__list",
  styles: "white-space:nowrap;display:flex;align-items:center;label:euiHeaderLinks__list;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "wu4i6o-euiHeaderLinks",
  styles: "display:flex;label:euiHeaderLinks;"
} : {
  name: "wu4i6o-euiHeaderLinks",
  styles: "display:flex;label:euiHeaderLinks;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiHeaderLinksStyles = function euiHeaderLinksStyles(_ref3) {
  var euiTheme = _ref3.euiTheme;
  return {
    euiHeaderLinks: _ref2,
    euiHeaderLinks__list: _ref,
    gutterSizes: {
      xs: /*#__PURE__*/css("gap:", euiTheme.size.s, ";;label:xs;"),
      s: /*#__PURE__*/css("gap:", euiTheme.size.m, ";;label:s;"),
      m: /*#__PURE__*/css("gap:", euiTheme.size.base, ";;label:m;"),
      l: /*#__PURE__*/css("gap:", euiTheme.size.l, ";;label:l;")
    },
    euiHeaderLinks__mobileList: /*#__PURE__*/css(".euiHeaderLink{display:block;", logicalCSS('width', '100%'), " padding:", euiTheme.size.s, ";&>.euiButtonEmpty__content{justify-content:flex-start;}};label:euiHeaderLinks__mobileList;")
  };
};